import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import Options, { Option } from './components/Options';
import { SortDirection } from 'types/common';

import './index.scss';
import Order from './components/Order';

interface Props {
  shortTitle: string;
  title: string;
  toRight?: boolean;
  isLast?: boolean;
  options: Option[];
  actualIndex: number;
  actualSort?: SortDirection;
  onChange: (value: any) => void;
  onSort?: (dir: SortDirection) => void;
}

interface State {
  visible: boolean;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

const b = b_.with('stocks-filter');

class Filter extends React.Component<Enhanced, State> {
  private dropdown: HTMLDivElement | null = null;
  readonly state: State = {
    visible: false,
  };

  render() {
    const { shortTitle, actualSort, isLast } = this.props;

    return (
      <div className={b({ 'is-last': isLast })}>
        {this.renderActualValue(shortTitle)}
        {actualSort && <div className={b('sort-icon', { dir: actualSort })} />}
        {this.renderDropdown()}
      </div>
    );
  }

  private renderDropdown() {
    const { title, options, actualIndex, actualSort, onSort, toRight } = this.props;

    const { visible } = this.state;

    if (!visible) {
      return null;
    }

    return (
      <div className={b('dropdown', { 'to-right': toRight })} ref={(el) => (this.dropdown = el)}>
        {this.renderActualValue(title)}
        <Options onClick={this.handleOptionClick} options={options} actualIndex={actualIndex} />
        {onSort && <Order actual={actualSort} onClick={this.handleOrderClick} />}
      </div>
    );
  }

  private renderActualValue(title: string) {
    return (
      <div className={b('actual')} onClick={this.handleClick}>
        <div className={b('title')}>{title}</div>
        <div className={b('value', { active: this.isActive() })}>{this.getActualValue()}</div>
      </div>
    );
  }

  private getActualValue() {
    const { options, actualIndex } = this.props;
    return options[actualIndex]
      ? options[actualIndex].titleAsActual || options[actualIndex].title
      : null;
  }

  private handleOptionClick = (value: any) => {
    this.props.onChange(value);
    this.setState(({ visible }) => ({ visible: !visible }));
  };

  private handleOrderClick = (value: SortDirection) => {
    const { onSort } = this.props;
    onSort && onSort(value);
    this.setState(({ visible }) => ({ visible: !visible }));
  };

  private handleClick = () => {
    this.setState(({ visible }) => ({ visible: !visible }));
  };

  componentDidMount() {
    if (typeof window === 'undefined') {
      return;
    }
    window.document.addEventListener('mousedown', this.onOutsideClick);
  }

  componentWillUnmount() {
    if (typeof window === 'undefined') {
      return;
    }
    window.document.removeEventListener('mousedown', this.onOutsideClick);
  }

  private onOutsideClick = (e: MouseEvent) => {
    if (this.dropdown && !this.dropdown.contains(e.target as Node)) {
      this.setState({ visible: false });
    }
  };

  private isActive() {
    return this.props.actualIndex > 0;
  }
}

export default enhance(Filter);
